import { CssSelectors } from '../../../../web/styles/styles';
import { charmGray } from '../../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	approvalReminderModal: {
		...CssSelectors.allDescendants(
			{
				maxWidth: 420,
			},
			'.modal-overlay-content'
		),
	},
	container: {
		height: '100%',
	},
	selectLabel: {
		color: charmGray,
		fontSize: 11,
		marginBottom: 4,
		textTransform: 'uppercase',
		display: 'block',
	},
	accountContentCalendarHeader: {
		width: 300,
	},
});
